import { useTranslation } from 'react-i18next';
import { HeaderActionType } from '../../../../SharedComponents/Header/HeaderActionType';
import {
    ButtonResource,
    HeaderResource,
    ImageResource,
    TextResource,
} from '../../../../Utils/PageUtils';
import { getUserDeviceModel } from '../../../../Services/ResourceService';
import { deviceModel } from '../../../../Models/SupportedDeviceModel';

export type SpeechComfortTestStartPageResource = {
    header: HeaderResource;
    instructionImage: ImageResource;
    instructionText: TextResource;
    button: ButtonResource;
};

export default function useSpeechComfortTestStartPageResource(): SpeechComfortTestStartPageResource {
    const { t } = useTranslation();

    return {
        header: {
            id: 'speech-comfort-header',
            text: t('speechComfort:SpeechComfort_Feature:Start:Header'),
            type: HeaderActionType.Menu,
        },
        instructionImage: {
            id: 'img-speechComfort',
            src: '/resources/speechComfort/speech-comfort_illustration.svg',
            alt: 'Speech Comfort Test',
        },
        instructionText: {
            id: 'speechComfort-instruction-text',
            text:
                getUserDeviceModel() == deviceModel.VibeGo
                    ? t('vibeGo:VibeGo_Device:SpeechComfort_Feature:Start:Text')
                    : t('speechComfort:SpeechComfort_Feature:Start:Text'),
        },
        button: {
            id: 'btn-continue-to-speechComfort-slider',
            label: t('common:Common_Feature:Continue'),
        },
    };
}
